import React from "react";
import { Card, Box, Typography, Chip, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CandidateMenu from "./CandidateMenu";

const CandidateCard = ({ candidate, tabType }) => {
  const navigate = useNavigate();

  // 遷移先を決定
  const handleCardClick = () => {
    if (tabType === "project") {
      navigate(`/company/candidates/${candidate.id}/contract_request`);
    } else if (tabType === "job") {
      navigate(`/company/candidates/${candidate.id}/job_request`);
    }
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        p: 3,
        mb: 2,
        border: "1px solid #ccc",
        borderRadius: 2,
        position: "relative",
        minHeight: 110,
        cursor: "pointer",
        "&:hover": { backgroundColor: "#fafafa" },
      }}
      onClick={handleCardClick}
    >
      {/* 右上メニュー */}
      <Box sx={{ position: "absolute", top: 14, right: 20, zIndex: 2 }}>
        <CandidateMenu candidate={candidate} tabType={tabType} />
      </Box>

      {/* イニシャル */}
      <Box
        sx={{
          width: 130,
          minWidth: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          letterSpacing={6}
          lineHeight={1.2}
        >
          {candidate.name}
        </Typography>
      </Box>

      {/* 募集状態 */}
      <Box
        sx={{
          width: 170,
          minWidth: 120,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack direction="column" spacing={1}>
          <Chip
            label={
              candidate.contract_recruiting
                ? "プロジェクト募集中"
                : "プロジェクト募集停止中"
            }
            size="small"
            color={candidate.contract_recruiting ? "secondary" : "default"}
            sx={{
              fontWeight: "bold",
              height: 24,
              fontSize: 13,
              borderRadius: 0,
              width: 160,
              maxWidth: 160,
            }}
          />
          <Chip
            label={
              candidate.job_recruiting ? "転職先募集中" : "転職先募集停止中"
            }
            size="small"
            color={candidate.job_recruiting ? "primary" : "default"}
            sx={{
              fontWeight: "bold",
              height: 24,
              fontSize: 13,
              borderRadius: 0,
              width: 160,
              maxWidth: 160,
            }}
          />
        </Stack>
      </Box>

      {/* 詳細情報 */}
      <Box
        sx={{
          flex: 1,
          px: 2.5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.2 }}>
          エンジニア歴 {candidate.engineer_history}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.2 }}>
          {candidate.nationality} / {candidate.gender} / {candidate.age}歳
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {candidate.nearest_station_line || "最寄り沿線：未設定"}
          {" / "}
          {candidate.nearest_station || "最寄り駅：未設定"}
        </Typography>
      </Box>
    </Card>
  );
};

export default CandidateCard;
